// Listing-honesty label (see Terms §2): who vouched for this organization.
export const VettedLabel = ({ vettedBy, className = "" }) => {
  if (!vettedBy) return null;
  const vetted = vettedBy === "stars4peace";
  return (
    <span
      className={`inline-flex items-center text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full ${vetted ? "bg-[#2E5C55]/10 text-[#2E5C55]" : "bg-[#E8E6E1] text-[#5C5C5C]"} ${className}`}
      title={vetted ? "Reviewed by Stars 4 Peace before listing" : "Submitted by the community; not reviewed by Stars 4 Peace"}
      data-testid={vetted ? "vetted-label-s4p" : "vetted-label-community"}
    >
      {vetted ? "Vetted by Stars 4 Peace" : "Community-submitted"}
    </span>
  );
};
